import type { DeepPartial } from '@luna/utils-ts';
import type { CardsFeatureConfig } from '@shared/cards-config';

import {
    CardBankHeaderFeatureConfig,
    CardLimitsChangeFeatureConfig,
    CardsSettingsCardDetailsFeatureConfig,
    CreditCardContentBoxFeatureConfig,
    CreditSharedFeatureConfig,
    DebitCardContentBoxFeatureConfig,
} from './featureConfig';

export const cards: DeepPartial<CardsFeatureConfig> = {
    components: {
        bankCardHeader: CardBankHeaderFeatureConfig.RS,
        settings: {
            cardDetails: CardsSettingsCardDetailsFeatureConfig.RS,
        },
        creditCardContentBox: CreditCardContentBoxFeatureConfig.RS,
        debitCardContentBox: DebitCardContentBoxFeatureConfig.RS,
        limitsChange: CardLimitsChangeFeatureConfig.RS,
    },
    credit: CreditSharedFeatureConfig.RS,
    bank: {
        showAsProduct: true,
        hideOverlayOnCardImage: true,
        hideAliasInCardHeader: true,
        showValidityInCardHeader: true,
    },
};
